import angular from 'angular';


let inject = [
    'BlogDetailService',
    'SharedService',
    '$stateParams'
];

class BlogDetailController {
    constructor(BlogDetailService,SharedService,$stateParams) {
        this.BlogDetailService = BlogDetailService;
        this.$stateParams= $stateParams;
        this.SharedService=SharedService;
        this.blogSlug = this.$stateParams.blogSlug || '';
        this.pageName = "PAG-45";
        this.SharedService.getCMSBanners(this.pageName, __env.adaptative ? 1:0).then(response => {
          this.cmsData = response;
          this.shCtrl.setTags(this.cmsData.seo);
        });
    }

    $onInit() {

      this.BlogDetailService.getPost(this.blogSlug).then(response => {
        this.article=response.post;

      });
      this.BlogDetailService.getPanelBlog().then(response => {
        this.recenPost=response.recentposts;
        this.categories=response.categories;
        this.tags=response.tags;
      });
    }




}

BlogDetailController.$inject = inject;

export default BlogDetailController;




// WEBPACK FOOTER //
// ./www/components/blog/blog-detail/blog-detail.controller.js